import axios from 'axios'
import { stringify } from 'qs'
import settings from '@/settings'

const instance = axios.create({
  baseURL: settings.apiHost,
  paramsSerializer: (params) => stringify(params)
})

instance.CancelToken = axios.CancelToken

export default instance
